import { Trans } from '@lingui/macro'
import { Alert, AlertTitle } from '@mui/material'
import { ReduxOrganization, ReduxState, ReduxUser } from 'app/redux/ReduxInterfaces'
import React from 'react'
import { useSelector } from 'react-redux'

export const NoOrganizationAccessBanner: React.FC<{}> = () => {
  const organization = useSelector<ReduxState, ReduxOrganization>((state) => state.organization)
  const user = useSelector<ReduxState, ReduxUser>((state) => state.user)

  const isManager =
  Boolean(user.organizationMember &&
  user.organizationMember.TeamMemberRole === 'Manager')

  if (!organization.id || isManager) {
    return null
  }

  return (
    <Alert variant='filled' severity='info'>
      <AlertTitle>
        <Trans>
          You are not authorized to create new applications for this
          organization. Please contact your account manager.
        </Trans>
      </AlertTitle>
      <Trans>FUNDING_NO_MANAGER_BANNER_INFO</Trans>
    </Alert>
  )
}
